export default {
  namespaced: true,

  state: {
    showTimeBlockModal: false,
    showTimeBlockEditModal: false
  },

  mutations: {
    SET_SHOW_TIME_BLOCK_MODAL(state, value) {
      state.showTimeBlockModal = value;
    },
    SET_SHOW_TIME_BLOCK_EDIT_MODAL(state, value) {
      state.showTimeBlockEditModal = value;
    }
  },

  actions: {
    openTimeBlockModal({ commit }) {
      commit('SET_SHOW_TIME_BLOCK_MODAL', true);
    },

    closeTimeBlockModal({ commit }) {
      commit('SET_SHOW_TIME_BLOCK_MODAL', false);
    },

    openTimeBlockEditModal({ commit }) {
      commit('SET_SHOW_TIME_BLOCK_EDIT_MODAL', true);
    },

    closeTimeBlockEditModal({ commit }) {
      commit('SET_SHOW_TIME_BLOCK_EDIT_MODAL', false);
    }
  }
};